import { Slide } from "react-awesome-reveal";
import { Avatar, Chip, Stack, Tooltip, Typography } from "@mui/material";

import { useAuthContext } from "../../Context/AuthContext";
import { type MessageUser } from "./types";
import { extractAttachments } from "./utils";

type PropsUser = {
  message: MessageUser;
  disableAnimation: boolean;
};

export const MessageUserComponent = ({ message, disableAnimation }: PropsUser) => {
  const { currentUser } = useAuthContext({ mustHaveUser: true });

  const { cleanedMessage, attachments } = extractAttachments(message.content);

  return (
    <Slide direction="up" triggerOnce duration={disableAnimation ? 0 : undefined}>
      <Stack
        alignSelf="center"
        borderTop={1}
        borderBottom={1}
        borderColor="divider"
        sx={{
          p: 2,
          backgroundColor: "background.paper",
        }}
      >
        <Stack
          sx={{
            alignSelf: "center",
            maxWidth: 800,
            width: "100%",
          }}
        >
          <Stack sx={{ alignSelf: "flex-start" }} direction="row" spacing={1.5}>
            <Avatar sx={{ height: 24, width: 24 }} src={currentUser.photoURL ?? undefined} />
            <Stack direction="column">
              <Typography variant="subtitle2">{cleanedMessage}</Typography>
              <Stack direction="row" spacing={1} mt={attachments.length > 0 ? 3 : 0}>
                {attachments.map((attachment) => (
                  <Tooltip title={attachment} key={attachment}>
                    <Chip
                      label={attachment.length > 20 ? `${attachment.slice(0, 20)}...` : attachment}
                      variant="outlined"
                      size="small"
                    />
                  </Tooltip>
                ))}
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Slide>
  );
};
